import * as React from 'react';
import { UIText3 } from '@cian/ui-kit';

import { IMultilineTotalProps } from '../../types';
import { DetailRow } from '../DetailRow';
import { TotalRow } from '../TotalRow';
import * as styles from './MultilineTotal.css';

export const MultilineTotal = ({ details, total, notEnoughMasterMoney }: IMultilineTotalProps) => {
  return (
    <div className={styles['wrapper']}>
      {details.map((detail, i) => (
        <DetailRow key={i} {...detail} />
      ))}

      <TotalRow total={total} />

      {notEnoughMasterMoney && (
        <div className={styles['not-enough-money']}>
          <UIText3 color="black_60">Не хватает денег на счёте агентства</UIText3>
        </div>
      )}
    </div>
  );
};
